export default __webpack_public_path__ + "static/media/Sting of the Repugnant.66d1c23d.jpg";